    <template >
  <div v-role="roles">

  <div>
  <div class="formPosition">

  <template>

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-container class="text-md-left">
        <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-overlay :value="overlay">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
              <v-list flat>
                <v-btn to="Listagem-preparar-certificado" class="mx-2" v-if="!progresso" fab dark color="primary" v-on="on">
                  <v-icon dark>arrow_back</v-icon>
                </v-btn>

                <v-progress-circular
                        v-if="progresso"
                        :size="50"
                        color="green"
                        indeterminate
                      ></v-progress-circular>
                    <span v-if="progresso">Carregando os dados , por favor aguarde ...</span>
                 <v-header>
                   <div style="text-align:center">
                  Preparação de Certificado - Lançamento de Notas - Estudante :<strong> {{this.$store.state.objaluno.nome}}</strong><br>
                  Turma:  <strong>{{this.$store.state.turma}}</strong> <br>

                </div>

                <div
                    v-if="$store.state.hasMessage" style="position:fixed;background-color:green;color:white;"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>

                  <div style="text-align:right">
                    <v-btn style="margin-right:15px;" v-if="showPrint" fab small color="green" @click="ImprimirCertificado()" ><v-icon color="white;">print</v-icon></v-btn>
                    <v-btn v-if="!progresso"  small color="primary" @click="FinalizarPreparacao()">Finalizar  </v-btn>
                  </div>

                </v-header>
                <hr width="1007px" />

                <v-list-item-group v-model="item" color="primary">
                  <!--  1 e 2 trimestre  header -->
                  <v-row  style="margin-left:50px">
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="5">Disciplinas</v-col>

                    <v-col cols="12" sm="12" md="1">Nota</v-col>

                    <v-col cols="12" sm="12" md="1"></v-col>

                    <v-col cols="12" sm="12" md="1"></v-col>

                    <v-col cols="12" sm="12" md="3" v-if="!showPrint">Action</v-col>
                  </v-row>

                  <!-- end  list  header  -->

                  <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <!-- body 1  trimestre -->

                 <v-row  >
                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="5">
                        <v-list-item-title v-text="item.descricao" v-if="item.iddisciplina >0"></v-list-item-title>
                        <v-list-item-title v-if="item.iddisciplina <0"><span style="font-weight:bold;">{{item.descricao}}</span></v-list-item-title>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.iddisciplina" class="text-lowercase">{{item.mfd}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.iddisciplina"
                          v-model="editedItem.mfd"
                          single-line
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">

                      </v-col>

                      <v-col cols="12" sm="12" md="1">

                      </v-col>

                      <v-col cols="12" sm="12" md="2">
                        
                         <v-btn
                          color="secondary"
                          fab
                          x-small
                          dark
                          v-if="(editedpk!==item.iddisciplina) &&  (item.idPauta === null || item.idPauta === undefined )"
                          class="mr-2"
                          @click="bt_edit(item)"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>

                         <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                               dark
                              v-bind="attrs"
                              v-on="on"
                              color="info"
                              fab
                              x-small
                              v-if="(editedpk!==item.iddisciplina) && (item.idPauta !== null && item.idPauta !== undefined )"
                              class="mr-2"
                              @click="bt_edit(item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Está média foi obtida da Pauta</span>
                        </v-tooltip>


                        <v-btn
                          color="red"
                          fab
                          x-small
                          dark
                          v-if="(editedpk!==item.iddisciplina && item.modif === 'duplicado')"
                          class="mr-2"
                          @click="bt_eliminar(item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <v-btn
                          color="primary"
                          fab
                          x-small
                          dark
                          v-if="(editedpk===item.iddisciplina)"
                          :disabled="!formValid"
                          @click="bt_save(editedItem)"
                        >
                          <v-icon>save_alt</v-icon>
                        </v-btn>

                        
                      </v-col>

                    </v-row>

                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      <!--   -->
 <v-row justify="center">
    <v-dialog v-model="dialogCert" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-row>
            <v-col>
        <v-icon x-large color="yellow">report_problem</v-icon><span style="font-size:18px; font-weight:bold"> Desejas continuar essa operação?</span>
        </v-col>
        </v-row>
          </v-card-title>
        <v-card-text><span style="color:red"> Esta operação resultará na cobrança deste serviço</span>, se desejares continuar clique em concordar

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn color="green darken-1" text @click="comporCertificado($store.state.objaluno, true, false)">Pré-vizualizar</v-btn>
          <v-btn color="green darken-1" text @click="certificadoPago()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialogCert=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar o sistema como um todo, desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="save_changes()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>






            <v-row justify="center">
            <v-dialog v-model="dialogNotaPauta" persistent max-width="500">
              <v-card>
                <v-card-title class="headline">Nota informativa</v-card-title>
                <v-card-text>A alteração da nota, implicará também uma alteração nas notas da Pauta, <span style="font-weight:bold;">Deseja continuar com a operação ?</span></v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogNotaPauta=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="saveAlteracaoNota()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->


 <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialog_mudar_medias" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Deseja continuar com essa operação?</v-card-title>
                <v-card-text>Não modifica esta nota, porque ela é calculada de modo automático.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="CancelarModificacaoMedia()">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="saveMudarMedia()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->



         <!-- ================================================ -->

            <v-row justify="center">
            <v-dialog v-model="dialog2" persistent max-width="490">
              <v-card>
                <div
                    v-if="$store.state.hasMessage"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Tens certeza de que desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog2=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="FinalizarPreparacao()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->

      </v-container>
      </v-form >
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
import axios_outside from '../../plugins/axios_outside'
// import jsreport from 'jsreport-browser-client-dist/jsreport'
import QRCode from 'qrcode'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    readImage: ls.get('urlReport') + `readfile/`,
    configuracoesReport: [],
    generateQR: null,
    formValid: true,
    overlay: false,
    dialog_mudar_medias: false,
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 10 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v== null || v.length == 2) || 'valor inválido'

    ],
    dialogCert: false,
    rascunhoimge: 'https://softlineangola.com/wp-content/uploads/2020/04/rascunho-1.png',
    roles: 'prof',
    text: '',
    url: ``,
    showPrint: false,
    PreparacaoNCompleta: false,
    itemDelete: null,
    editedpk: 0,
    profediscinas: [],
    role_usuario: '',
    disciplinas: [],
    _classe: '',
    Professor: '',
    dialog: false,
    dialog2: false,
    dialogNotaPauta: false,
    dialogoDisabilita: false,
    progresso_2: false,
    progresso_3: false,
    progresso: false,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: '',
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    item: 1,
    objNotas: null,
    objNotasCancelar:null,
    canPrint: [],
    listaPautasBloquadas: [],
    componente: [],
    componente2: [],
    componente3: [],
    componente4: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,

    editedItem: {
      descricao: '',
      idPauta: '',
      iddisciplina: '',
      mfd: 0,
      p1_notaMac: '',
      idcertificado: 0,
      componente:''
    }
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    role () {
      return ls.get('role')
    },

    instituicao(){
      return ls.get('i_id')
    },

    TodasNotasLançadas(){
        
        return this.listEstudantfromPauta.filter (c=>c.mfd === null ).length === 0
    },

    anolectivoEstudante () {
      return this.$store.state.objaluno.anoLectivo
    },

    anolectivoActual () {
       return ls.get('anolectivo')
    },

    estudanteCertificadoJaEmitido (){
        return (this.$store.state.objaluno.certificado === "1")?true:false
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    console.log(this.$store.state.objaluno);
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // this.CarregActividades()
    //this.pautaByTurma()´ (estudanteCertificadoJaEmitido && parseInt(anolectivoActual) > parseInt(anolectivoEstudante))
    this.listEstudantfromPauta = this.EncontrarDuplicados(this.$store.state.listEstudantfromPauta)
    if(this.listEstudantfromPauta.length){
        this.CalculaMediaFinal(this.$store.state.objaluno.idMatricula,ls.get('nomeUsuario'),'inicializarCALCULOS')
    }
    this.carregarConfiguracoesReports()
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    EncontrarDuplicados (arr){
          
      arr.forEach(element => {
          let duplicado = arr.filter( e=>e.descricao === element.descricao ).length
          const indexOf = arr.indexOf(element)
          if(duplicado>1){
             arr[indexOf].modif = 'duplicado'
          }else{
              arr[indexOf].modif = null
          }
      });

      return arr


    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.iddisciplina
      this.objNotasCancelar = Object.assign({}, item)
      setTimeout(() => {}, 1000)
    },

    CancelarModificacaoMedia(){
      this.dialog_mudar_medias = false
      this.save(this.objNotasCancelar,false)
    },

    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },

    saveMudarMedia() {
      if (this.formValid) {
        this.dialog_mudar_medias = false
        this.save(this.objNotas,true)
      }
    },

    bt_save (editedItem) {
          this.objNotas = editedItem
      if( editedItem.idPauta !== null &&  editedItem.idPauta !== undefined){
          this.dialogNotaPauta = true
      }else{
          if(editedItem.iddisciplina < 0){
            this.dialog_mudar_medias = true
          }else{
            if (this.formValid) {
                  this.save(editedItem,false)
                } 
          }

      }

     
    },

    bt_eliminar(item){
      let index = this.listEstudantfromPauta.indexOf(item)
      this.listEstudantfromPauta.splice(index,1)
      this.EncontrarDuplicados(this.listEstudantfromPauta)
    },


    backTodisciplinList () {
      this.listEstudantfromPauta = []
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async turmaFindWithEstudanteCount (idclasse) {
      this.progresso = true
      try {
        this.progresso = true
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
     save (editedItem, isMedia) {
      Object.assign(this.listEstudantfromPauta[this.editedIndex], editedItem)
      this.editedpk = 0
      if(!isMedia){ // Faz apenas o calculo das medias se a nota modificada for uma média.
          setTimeout(() => {
            this.CalculaMediaFinal(this.$store.state.objaluno.idMatricula,ls.get('nomeUsuario'),'recalcularMedias')
        }, 1000);
      }
    },

    async saveAlteracaoNota () {        
        try {
          
        let result = await axios.post('/alteracao-nota-certificado-pauta',this.objNotas).then(res=>res.data)
        if(result.affectedRows >= 1){
          this.$store.dispatch('textMessage', {msg: 'Nota Gradava com sucesso!',classMessage: 'msgSucess',timeout: 3000})
          this.save(this.objNotas,false)
          this.dialogNotaPauta = false
        }else{
           this.$store.dispatch('textMessage', {msg: 'Ocorreu um erro!',classMessage: 'msgError',timeout: 3000})
        }

        } catch (error) {
          
        }
    },

    async Teste(){

      try {
        
       return  await axios_outside
        .get('/teste').then(res=>res.data)

      } catch (error) {
        
      }

    },

    async pautaByTurma () {
      // carrega turma apartir de bauta  Turma
      try {
        let idmatricula = this.$store.state.objaluno.idMAtricula
        this.progresso_3 = true
        this.progresso = true
        this.listEstudantfromPauta = await axios
          .get('/preparar-certificado-listagem/' + idmatricula)
          .then(res => res.data)
        this.listEstudantfromPauta.forEach(element => {
          element.anoacademico = parseInt(element.anoacademico)
          if (element.mfd !== null) { this.PreparacaoNCompleta = false }
        })
        
        this.progresso_3 = false
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso_3 = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {msg: error,classMessage: 'msgError',timeout: 3000})
      }
    },

    CalculaMediaFinal (matricula_,autor_, from){
      let soma = 0;
      let pc  = 0;
      let mediaFinal = 0
      let Pap = this.listEstudantfromPauta.filter(c=>c.descricao === 'Classificação da Prova de Aptidão Profissional (PAP)')
      let Ec = this.listEstudantfromPauta.filter(c=>c.descricao === 'Classificação do Estágio Curricular(EC)')
      this.listEstudantfromPauta.forEach(element => {
        if(element.iddisciplina >0)
           soma += (element.mfd === null)?0: parseInt(element.mfd)
      });
      pc = Math.round(soma / parseInt(this.listEstudantfromPauta.length-2))
      mediaFinal = Math.round((4 * pc + parseInt(Pap[0].mfd) + parseInt(Ec[0].mfd)) / 6)

      if(from  === 'recalcularMedias'){
          this.listEstudantfromPauta.filter(c=>c.descricao === 'Classificação Final do Plano Curricular (PC)')[0].mfd = pc
          this.listEstudantfromPauta.filter(c=>c.descricao === 'Classificação Final do Curso=(4XPC+PAP+EC)/6')[0].mfd=mediaFinal
      }
      else{

           /**
           * Verifica se disciplinas de classificação foram inseridas
          */
          let classFinal = this.listEstudantfromPauta.filter(c=>c.descricao === 'Classificação Final do Curso=(4XPC+PAP+EC)/6')
          let classPlanoCurricular = this.listEstudantfromPauta.filter(c=>c.descricao === 'Classificação Final do Plano Curricular (PC)')
          if(!classPlanoCurricular.length)
            this.listEstudantfromPauta.push({matricula:matricula_,autor:autor_,id_disciplina:-1,iddisciplina:-1,disciplina:'Classificação Final do Plano Curricular (PC)',descricao:'Classificação Final do Plano Curricular (PC)',idcertificado:0,mfd:pc,componente:3})
          if(!classFinal.length)
            this.listEstudantfromPauta.push({matricula:matricula_,autor:autor_,id_disciplina:-2,iddisciplina:-2,descricao:'Classificação Final do Curso=(4XPC+PAP+EC)/6',idcertificado:-2,mfd:mediaFinal,componente:3})
        }

 
      },



    ImprimirCertificado (){
       window.open('http://certificado.softlineangola.com/#/login/?q=' + this.$store.state.objaluno.idMAtricula + '/' + ls.get('token'), '_blank').focus()
    },

    async initprofdisc (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    
    
    async save_certificado () {
      try {
         let params =  {
            id_certificado: 0,
            iddisciplina: this.editedItem.iddisciplina,
            disciplina: this.editedItem.descricao,
            nota: this.editedItem.mfd,
            componente: this.editedItem.componente,
            autor: ls.get('nomeUsuario'),
            fk_Dados: this.$store.state.objaluno.pkPessoa,
            matricula: this.$store.state.objaluno.idMAtricula,
            notas: this.listEstudantfromPauta,
            nome: this.$store.state.objaluno.nome,
            matricula: this.$store.state.objaluno.idMAtricula,
            bi: this.$store.state.objaluno.bi,
            data_nascimento: this.$store.state.objaluno.datanascimento,
            data_emissao:this.$store.state.objaluno.dataemissaobi,
            nome_pai: this.$store.state.objaluno.nomedopai,
            nome_mae:this.$store.state.objaluno.nomedamae,
            classe:this.$store.state.objaluno.classe,
            id_ano_academico:this.$store.state.objaluno.idAno_Academico,
            curso:this.$store.state.objaluno.curso,
            id_curso:this.$store.state.objaluno.idCurso,
            resultado: this.$store.state.objaluno.curso,
            ano_lectivo:this.$store.state.objaluno.novadescricao,
            id_ano_lectivo: this.$store.state.objaluno.idAno_Academico,
            instituicao:this.$store.state.objaluno.instituicaodescricao,
            fk_instituicao:this.$store.state.objaluno.instituicao,
            provincia:this.$store.state.provincia,
            municipio:this.$store.state.municipio,
            turno: (this.$store.state.objaluno.periodo === "Manhã" || this.$store.state.objaluno.periodo === "Tarde")?"Diurno":"Noturno",
            foto:this.$store.state.objaluno.resultado,
            autor:ls.get('nomeUsuario'),
            numero_disciplinas: (this.$store.state.objaluno.numero_disciplinas+2),
            pkPessoa:this.$store.state.objaluno.pkPessoa,
            certificado:true,
            sexo: (this.$store.state.objaluno.pkPessoa.sexo === 'M')?"Masculino":"Femenino",
            numero_disciplinas:null
          }

        return await axios_outside
        .post('/certificadoInsertOrUpdate',params)
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text + ' - ' + error,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
    },

    async certificadoPago () {
      let item = this.$store.state.objaluno
      try {
        this.certificadosPago = await axios
          .get('/certificadoPago/' + item.pkPessoa)
          .then(res => res.data)
        // Se o certificado estiver pago então enviar-se-á os dados do aluno e a permissão de imprimir sem o rascunho
        // Se o certificado não estiver pago então checamos se a saldo disponivel nesta instituição
        if (this.certificadosPago.length > 0) { this.comporCertificado(item, false, false) } else { this.verificarPagamentoCertificado() }
      } catch (error) {
        this.text = error
      }
    },
    async  verificarPagamentoCertificado () {
      this.dialogCert = false
      try {
        this.canPrint = await axios
          .get('/verificarPagamento/' + this.$store.state.objaluno.instituicao)
          .then(res => res.data)

        if (this.canPrint.length && this.canPrint[0].quantidade_final > this.canPrint[0].consumo) {
          this.comporCertificado(this.$store.state.objaluno, false, true)
        } else {
          // Imprimir com o rascunho e não fará desconto
          this.comporCertificado(this.$store.state.objaluno, true, false)
        }
      } catch (error) {
        this.text = error
      }
    },
    async comporCertificado (dados, isRascunho, canDescontar) {

      // window.open('http://localhost:8080/#/?q=' + this.$store.state.objaluno.idMAtricula + '/' + ls.get('token'), '_blank').focus()
      console.log(dados);
      console.log(ls.get('token'));
        
    },
    async gerarPdfCertificado (option, canDescontar) {
      this.progresso = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile', //  http://relatorios.softlineangola.com
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF

        this.progresso = false
        this.frameCertificado(canDescontar)
      } catch (error) {
        this.progresso = false
      }
    },
    frameCertificado (canDescontar) {
      if (canDescontar) {
        this.descontarEmulumentoPago()
        this.insertImprimirCertificado(this.$store.state.objaluno)
      }
      let link = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
      this.progresso = false
    },
    async descontarEmulumentoPago () {
      // eslint-disable-next-line no-unused-vars
      let descontandoEmolumento
      const value = {
        pkpagamentoEmolumento: this.canPrint[0].pkpagamentoEmolumento,
        consumo: ((this.canPrint[0].consumo) + 1),
        idPessoa: ls.get('nomeUsuario')
      }
      try {
        descontandoEmolumento = await axios
          .post('/DescontarEmolumentoPago', value)
          .then(res => res.data)
      } catch (error) {
        console.log('A API DescontandoEmolumento) ' + error)
        this.text = error
      }
    },
    async insertImprimirCertificado (item) {
      const value = {
        pkPessoa: item.pkPessoa,
        matricula: item.idMatricula,
        autor: ls.get('nomeUsuario')
      }
      try {
        // eslint-disable-next-line no-unused-vars
        let insertCertificadoPago = await axios
          .post('/insertImprimirCertificado', value)
          .then(res => res.data)
      } catch (error) {
        this.text = error
      }
    },
    monthName () {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    dia () {
      var day = new Date()
      day = day.getDate()
      day = day.toString()
      return day
    },
    rascunho (putRascunho) {
      return putRascunho === true ? this.rascunhoimge : ''
      // return ''
    },
    extensao (valor) {
      switch (valor) {
        case '10':
          return 'Dez'
        case '11':
          return 'Onze'
        case '12':
          return 'Doze'
        case '13':
          return 'Treze'
        case '14':
          return 'Catorze'
        case '15':
          return 'Quinze'
        case '16':
          return 'Dezasseis'
        case '17':
          return 'Dezassete'
        case '18':
          return 'Dezoito'
        case '19':
          return 'Dezanove'
        case '20':
          return 'Vinte'
        case 10:
          return 'Dez'
        case 11:
          return 'Onze'
        case 12:
          return 'Doze'
        case 13:
          return 'Treze'
        case 14:
          return 'Catorze'
        case 15:
          return 'Quinze'
        case 16:
          return 'Dezasseis'
        case 17:
          return 'Dezassete'
        case 18:
          return 'Dezoito'
        case 19:
          return 'Dezanove'
        case 20:
          return 'Vinte'

        default:
          return 'Valor inválido'
      }
    },

    convertDate (dateString) {
      var p = dateString.split('-')
      // eslint-disable-next-line standard/array-bracket-even-spacing
      return [p[2], p[1], p[0] ].join('/')
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report' })
          .then(res => res.data)
        // console.log(msg)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    },
    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
            {
              turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
              disciplina: this.$store.state.disciplina,
              trimestre: this.$store.state.lancarNotaDe,
              bloquear: 0,
              publicar: 0,
              idControlopauta: this.$store.state.Controlopauta
            }

        try {
          // eslint-disable-next-line no-unused-vars
          let valor = await axios

            .post('/bloquearPauta', valores)
            .then(res => res.data)
          // eslint-disable-next-line no-unused-vars
          let text = 'Pauta Bloqueada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.CarregaPautas()
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    async  FinalizarPreparacao () {


      if( !this.TodasNotasLançadas && (this.instituicao !== 144 && this.instituicao !== 5) ){
        Swal.fire('Informação','Não terminou de lançar todas as notas'+this.instituicao,'info')
      }else{
      //
      //this.pautaByTurma()
      this.overlay = true
       
      if (!this.PreparacaoNCompleta) {
         this.save_certificado().then((res)=>{
            if(res.data.affectedRows >= 1){
              this.actualizarStatusPreparado(this.$store.state.objaluno.idMAtricula).then((resp)=>{
                this.overlay = false
                 if(resp.affectedRows >= 1){
                     this.$store.dispatch('textMessage', {msg: 'Certificado preparado com sucesso.',classMessage: 'msgSucess',timeout: 3000})
                      let certificadoUrl = (ls.get('ims') === 'IMS-Luanda')?'http://certificado.softlineangola.com':'http://certificado.softlineangola.net'
                     // let certificadoUrl = 'http://localhost:8080'
                      window.open(certificadoUrl+'/#/login/?q=' + this.$store.state.objaluno.idMAtricula + '/' + ls.get('token'), '_blank').focus()
                 }
              }).catch(error=>{
                console.log(error);
                this.overlay = false
                this.$store.dispatch('textMessage', {msg: 'Ocorreu um erro ao tentar efectuar a operação',classMessage: 'msgError',timeout: 3000})
              })
            }
         }).catch(error=>{
          console.log(error);
           this.overlay = false
           this.$store.dispatch('textMessage', {msg: 'Ocorreu um erro ao tentar efectuar a operação',classMessage: 'msgError',timeout: 3000
        })
         })
      } else {
        this.overlay = false
        this.$store.dispatch('textMessage', {
          msg: 'Ainda tem notas por lançar , por favor termine o lançamento de notas',
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      }
    },


    async actualizarStatusPreparado (matricula){

       try {
           return await axios

            .post('/actualizaStatusCertificado',{matricula:matricula})
            .then(res => res.data)
        } catch (error) {
             this.$store.dispatch('textMessage', { msg: 'Ocorreu um erro ao tentar efectuar a operação',classMessage: 'msgError',timeout: 3000
          })
        }
    },

   async SaveFinalizarOperacao (){
      let params = 
          {
            nome: this.$store.state.objaluno.nome,
            matricula: this.$store.state.objaluno.idMAtricula,
            bi: this.$store.state.objaluno.bi,
            data_nascimento: this.$store.state.objaluno.datanascimento,
            data_emissao:this.$store.state.objaluno.dataemissaobi,
            nome_pai: this.$store.state.objaluno.nomedopai,
            nome_mae:this.$store.state.objaluno.nomedamae,
            classe:this.$store.state.objaluno.classe,
            id_ano_academico:this.$store.state.objaluno.idAno_Academico,
            curso:this.$store.state.objaluno.curso,
            id_curso:this.$store.state.objaluno.idCurso,
            ano_lectivo:this.$store.state.objaluno.anoLectivo,
            id_ano_lectivo: this.$store.state.objaluno.idAno_Academico,
            instituicao: ls.get('instituicaodescricao'),
            fk_instituicao:this.$store.state.objaluno.instituicao,
            provincia:this.$store.state.objaluno.provincia,
            municipio:this.$store.state.objaluno.municipio,
            turno: (this.$store.state.objaluno.periodo === "Manhã" || this.$store.state.objaluno.periodo === "Tarde")?"Diurno":"Noturno",
            foto:null,
            autor:ls.get('nomeUsuario'),
            pkPessoa:this.$store.state.objaluno.pkPessoa,
            certificado:true,
            sexo: (this.$store.state.objaluno.pkPessoa.sexo === 'M')?"Masculino":"Femenino",
          }
        try {
        return await axios_outside

            .post('/dados-InsertorUpdate',params)
            .then(res => res.data)

        } catch (error) {
          this.$store.dispatch('textMessage', {msg: "Ocorreu um erro ao tentar efectuar a operação",classMessage: 'msgError',timeout: 3000 })
        }
    },

    MostraProfessor () {
      let valor = this.profediscinas.filter(d => d.iddisciplina === this.$store.state.disciplina)
      if (valor.length) {
        this.Professor = valor[0].nome
        this.descricao_Prof = 'disciplina atrbuida ao Professor'
      } else {
        this.Professor = 'Sem Professor Associado'
        this.descricao_Prof = ''
      }
    },

    async CarregaPautas () {
      if (!this.$store.state.bloqueado.length) {
        try {
          this.$store.state.bloqueado = await axios

            .get('/ListarPautaBloqueada')
            .then(res => res.data)
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    async  Eliminar (item) {
      this.itemDelete = item
      this.dialog = true
      //
    },
    save_changes () {
      let indexOf = this.listEstudantfromPauta.indexOf(this.itemDelete)
      this.EliminaItem(this.itemDelete, indexOf)
    },

    async EliminaItem (item, indexOf) {
      try {
        this.progresso_2 = true
        let msg = await axios

          .get('/deleteDisciplina-certificado/' + item.idcertificado)
          .then(res => res.data)
        this.progresso_2 = false

        if (msg.length) {

        } else {
          this.listEstudantfromPauta.splice(indexOf, 1)
          this.dialog = false
        }
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    HabilitaBotoes (valor) {
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '1º Trimestre')) {
        this.btn_activacao1 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '2º Trimestre')) {
        this.btn_activacao2 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '3º Trimestre')) {
        this.btn_activacao3 = valor
      }
    },

    verificaPautas () {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(block => block.turma === this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma && block.disciplina === this.$store.state.disciplina && block.publicar === 1 && block.bloquear === 1 && block.trimestre === this.$store.state.lancarNotaDe)
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true)

        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.HabilitaBotoes(false)
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_description = 'Bloquear'
        this.HabilitaBotoes(false)
      }
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      try {
        this.progresso_2 = true
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
        this.progresso_2 = false
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
